export default __webpack_public_path__ + "static/media/shopify-platform-poster.3c9ffdaa.png";